import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      if (data.token) {
        // First user (bootstrap admin) — auto-login handled by helper
        await register(form.email, form.password, form.name);
        toast.success("Nalog kreiran");
        window.location.href = "/";
        return;
      }
      setSubmitted(true);
      toast.success("Zahtev poslat administratoru");
    } catch (e) {
      toast.error(formatApiError(e));
    }
    setLoading(false);
  };

  if (submitted) {
    return (
      <div className="min-h-screen grid place-items-center p-6">
        <div className="w-full max-w-md surface-card p-8 text-center" data-testid="register-pending">
          <div className="overline mb-2">Registracija poslata</div>
          <h2 className="text-2xl font-heading font-semibold tracking-tight">Zahtev je na čekanju</h2>
          <p className="text-sm text-ink-muted mt-3">
            Administrator će uskoro odobriti tvoj nalog. Kada odobri, moći ćeš da se prijaviš uobičajenim putem.
          </p>
          <Link to="/login" className="btn-primary mt-6 inline-flex" data-testid="link-back-login">Nazad na prijavu</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <form onSubmit={submit} className="w-full max-w-md surface-card p-8" data-testid="register-form">
        <div className="overline mb-2">Registracija</div>
        <h2 className="text-3xl font-heading font-semibold tracking-tight">Kreiraj nalog</h2>
        <p className="text-sm text-ink-muted mt-2">Popuni podatke — administrator će odobriti tvoj pristup.</p>

        <div className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-medium">Ime</label>
            <input
              data-testid="register-name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full mt-1 px-3 py-2.5 bg-white border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-forest"
              required
            />
          </div>
          <div>
            <label className="text-sm font-medium">Email</label>
            <input
              data-testid="register-email"
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full mt-1 px-3 py-2.5 bg-white border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-forest"
              required
            />
          </div>
          <div>
            <label className="text-sm font-medium">Lozinka (min. 6)</label>
            <input
              data-testid="register-password"
              type="password"
              minLength={6}
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full mt-1 px-3 py-2.5 bg-white border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-forest"
              required
            />
          </div>
          <button data-testid="register-submit" disabled={loading} className="btn-primary w-full justify-center">
            {loading ? "Šaljem..." : "Pošalji zahtev"}
          </button>
        </div>

        <div className="text-sm text-ink-muted mt-6">
          Već imate nalog? <Link to="/login" data-testid="link-login" className="text-forest font-medium hover:underline">Prijavite se</Link>
        </div>
      </form>
    </div>
  );
}
